import React from "react";
import ContentLoader from "react-content-loader";
import { connect } from "react-redux";

class Loader2 extends React.Component {
  render() {
    return (
      <ContentLoader
        speed={2}
        width={500}
        height={3300}
        viewBox="0 0 500 3300"
        backgroundColor={` ${this.props.darkMode ? "#19202d" : "#e4e3e3"}`}
        foregroundColor={` ${this.props.darkMode ? "#303742" : "#ecebeb"}`}
        {...this.props}
      >
        <rect x="4" y="41" rx="0" ry="0" width="595" height="142" />
        <rect x="3" y="238" rx="0" ry="0" width="595" height="2394" />
        <rect x="-5" y="2739" rx="0" ry="0" width="595" height="345" />
        <rect x="14" y="3326" rx="0" ry="0" width="685" height="117" />
        <rect x="-6" y="3171" rx="0" ry="0" width="595" height="128" />
      </ContentLoader>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    darkMode: state.darkMode,
  };
};

export default connect(mapStateToProps)(Loader2);
